

import MaJiangTableView from "./bipai_table_view";
import MaJiangTableModel from "./bipai_table_model";
import Utility from "../../../../utility/utility";
import BiPaiTableModuleBase from "./bipai_table_module_base";
import NetMessageDataBiPaiGame from "../../net/bipai_net_msg_data_game";
import { BiPaiRoomInfo, BiPaiSeatInfo } from "./bipai_table_data";
import ModelData from "../../../public/model_data";
import { Card, CardColor, CardNameIndex } from "./bipai_card_common";
import { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import PromiseUtility from "../../../../utility/promiseUtility";
import ModuleManager from "../../../../framework/core/module_manager";
import BiPaiGoldOneGameResultModule from "../onegameresult/bipai_gold_onegameresult_module";
import { BiPaiGoldGameResultData } from "../onegameresult/bipai_gameresult_interface";
import SceneManager from "../../../../manager/scene_manager";
import GameServer from "../../../hall/server/gameserver/game_server";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import LanguageManager from "../../../../manager/language_manager";
import UserDataManager from "../../../../manager/user_manager";
import { joinUtil } from "../../../public/join_util";
import LoaclStorage from "../../../../manager/local_storage";
import DialogLeave from "../../../public/module/dialog_leave/dialog_leave";
import { Room } from "../../../table/net/proto/proto_poker_room";
import { BiPaiGame } from "../../net/proto/bipai_game";


const { ccclass } = cc._decorator;

const const_recycle_duration: number = 1
const const_recycle_interval: number = 0.1
const const_recycle_seat_interval: number = 0.133
const const_fapai_duration: number = 0.6
const const_fapai_single_interval: number = 0.1
const const_fapai_seat_interval: number = 0.1

const const_mopai_duration: number = 0.63
const const_discard_duraton: number = 1.3 * 0.8
const const_gold_fly_duration: number = 0.5


@ccclass
@moduleInit("BiPaiTableModule")
export default class BiPaiTableModule extends BiPaiTableModuleBase<MaJiangTableView, MaJiangTableModel>  {


    protected m_ack_id: number = 0
    protected m_can_follow_code_list: number[] = []

    protected m_is_playing_fapai_anim: boolean = false

    protected m_has_show_recorder: boolean = false

    protected m_need_show_assistant: boolean = false
    protected m_assistant_rate: number = 0

    initModule() {
        super.initModule(MaJiangTableView, MaJiangTableModel, 'package/bipai/bipai_table');
    }



    //重置module
    resetModule() {
        super.resetModule()

    }

    start() {
        super.start()
    }

    onInit(intentData: any) {
        super.onInit(intentData)
    }

    onHide() {
        super.onHide()
    }

    onShow(intentData) {
        // this.getRemoteRule = function(){
        //     return '{"playerCount":3}'
        // } 
        super.onShow(intentData)
        let goldData = ModelData.instance.tableCommonData.roomRuleData
        if(goldData){
            let baseScore = goldData.game_BetSingle
            let wanfaText = LanguageManager.t('Public＿BottomPouring') + baseScore
            this.view.showWanFaLabel(true, wanfaText)
        }                
        // this.test()
    }

    protected onApplicationShow(isShow) {
        super.onApplicationShow(isShow)
    }

    on_destroy() {
        super.on_destroy()
    }

    bindBtnClickEvent() {
        let self = this
        super.bindBtnClickEvent()
        // self.view.buttonOpenCard.node.on('click', self.on_click_btn, self)
        // self.view.buttonMoreCard.node.on('click', self.on_click_btn, self)
        // self.view.buttonFollow.node.on('click', self.on_click_btn, self)
    }

    unbindBtnClickEvent() {
        let self = this
        super.unbindBtnClickEvent()
        if(!this.view){
            return
        }
        self.view.buttonOpenCard.node.targetOff(self)
        self.view.buttonMoreCard.node.targetOff(self)
        self.view.buttonFollow.node.targetOff(self)
    }

    protected registEventMsg() {
        super.registEventMsg()
        let self = this
        self.eventBind("event_exit_game", self.on_click_menu_leave_btn);
    }

    protected unregisstEventMsg() {
        super.unregisstEventMsg()
        let self = this
        self.eventUnBind("event_exit_game", self.on_click_menu_leave_btn);
    }

    registNetMsg() {
        super.registNetMsg()
        let self = this
        self.model.subscibeMsgEvent<BiPaiGame.GameInfo>(NetMessageDataBiPaiGame.GameInfo, function (protoData) {
            self.onNetMsg_GameInfo(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.BankerNotify>(NetMessageDataBiPaiGame.BankerNotify, function (protoData) {
            self.onNetMsg_BankerNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.DealCardNotify>(NetMessageDataBiPaiGame.DealCardNotify, function (protoData) {
            self.onNetMsg_DealCardNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.MoreCardRsp>(NetMessageDataBiPaiGame.MoreCard, function (protoData) {
            self.onNetMsg_MoreCardRsp(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.MoreCardNotify>(NetMessageDataBiPaiGame.MoreCardNotify, function (protoData) {
            self.onNetMsg_MoreCardNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.OpenCardRsp>(NetMessageDataBiPaiGame.OpenCard, function (protoData) {
            self.onNetMsg_OpenCardRsp(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.DiscardRsp>(NetMessageDataBiPaiGame.Discard, function (protoData) {
            self.onNetMsg_DiscardRsp(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.DiscardNotify>(NetMessageDataBiPaiGame.DiscardNotify, function (protoData) {
            self.onNetMsg_DiscardNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.FollowRsp>(NetMessageDataBiPaiGame.Follow, function (protoData) {
            self.onNetMsg_FollowRsp(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.FollowNotify>(NetMessageDataBiPaiGame.FollowNotify, function (protoData) {
            self.onNetMsg_FollowNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.GameSettle>(NetMessageDataBiPaiGame.GameSettle, function (protoData) {
            self.onNetMsg_GameSettle(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.TimeoutNotify>(NetMessageDataBiPaiGame.TimeoutNotify, function (protoData) {
            self.onNetMsg_TimeoutNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.SysOpenRsp>(NetMessageDataBiPaiGame.SysOpen, function (protoData) {
            self.onNetMsg_SysOpenRsp(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.CardReocrderNotify>(NetMessageDataBiPaiGame.CardReocrderNotify, function (protoData) {
            self.onNetMsg_CardReocrderNotify(protoData)
        })

        self.model.subscibeMsgEvent<BiPaiGame.Assistant>(NetMessageDataBiPaiGame.Assistant, function (protoData) {
            self.onNetMsg_Assistant(protoData)
        })
    }


    protected onNetMsg_GameInfo(protoData: BiPaiGame.IGameInfo) {
        let self = this
        self.m_isGameInfoInited = true
        self.initSeatViewPos()
        self.initTableData(protoData)
        self.view.setIsGoldTable(self.getIsGoldTable())
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()        
        let mySeatInfo = roomInfo.mySeatInfo as BiPaiSeatInfo
        let seatInfoList = roomInfo.seatInfoList
        let wanfaText = LanguageManager.t('Public＿BottomPouring') + roomInfo.ruleTable.game_BetSingle
        self.view.showWanFaLabel(true, wanfaText)
        self.view.showLeaveBtn(false)
        self.view.showMoreBtn(true)
        self.view.showRecordLabel(true, protoData.roundSign)                
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as BiPaiSeatInfo
            if (!seatInfo.userInfo) {
                self.view.showSeatInfo(seatInfo.localPos, seatInfo.playerId, function (userInfoData) {
                    seatInfo.userInfo = self.genUserInfo(userInfoData)                    
                    self.tryRefreshAllChatRecordData()
                })
                self.view.getSeatViewByPos(seatInfo.localPos).showNoSeatDown(false)
            }
            self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
            self.view.showSeatBankerTag(seatInfo.localPos, seatInfo.isBanker)
            self.view.showSeatWatchTag(seatInfo.localPos, !seatInfo.isPlaying && roomInfo.state != 0 && roomInfo.state != 5)
            
            self.view.showSeatClock(seatInfo.localPos, roomInfo.currentSeat == seatInfo.remotePos, roomInfo.stateExpiredTime - protoData.time, seatInfo == mySeatInfo)
            if(seatInfo == mySeatInfo){
                self.view.mySeatCards.uid = mySeatInfo.playerId
                self.view.mySeatCards.showPokers(protoData.state != 0, seatInfo.cards, {pointNum: seatInfo.cardPoint})
            }else{
                self.view.bindSeatHandCardsUid(seatInfo.localPos, seatInfo.playerId)
                self.view.showSeatHandCards(seatInfo.localPos, protoData.state != 0, seatInfo.cards)
            }  
            self.view.bindSeatMingHandCardsUid(seatInfo.localPos, seatInfo.playerId)    
            for (let i = 0; i < seatInfo.discards_list.length; i++) {
                const element = seatInfo.discards_list[i];
                self.view.bindSeatDispatchCardsUid(seatInfo.localPos, seatInfo.playerId)
                self.view.showSeatDispatchCards(seatInfo.localPos, true, false, element)
            }      
        }
        self.view.showPokerHeap(roomInfo.isRoundStarted, roomInfo.pokerHeapCount)
        self.view.mySeatCards.setCustomOnFinishDragFunc(self.onFinishDragPoker.bind(self))

        self.refreshBtns() 
        
        if(roomInfo.state == 0 || roomInfo.state == 5){
            let inCount = 0
            for (let index = 0; index < seatInfoList.length; index++) {
                const seatInfo = seatInfoList[index];
                if(seatInfo.playerId){
                    inCount++
                }
            }
            if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){      
                self.showWaitStartSecsPanel(true, 1)
            }
        }else{
            self.view.showFollowMultiple(roomInfo.ruleTable.game_EnableFollowRate, protoData.followRate)
        }
        this.eventDispatch('Game_Table_Start');
    }

    protected onFinishDragPoker(){
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as BiPaiSeatInfo
        if(!self.m_is_playing_fapai_anim && roomInfo.currentSeat == mySeatInfo.remotePos && (roomInfo.discardSeatId == mySeatInfo.remotePos || self.m_can_follow_code_list.length > 0)){  
            let lastSelectData = self.view.mySeatCards.getSelectedPokers() 
            self.view.mySeatCards.refreshPokerSelectState(false)         
            if(roomInfo.discardSeatId == mySeatInfo.remotePos){
                let selectedData = self.view.mySeatCards.getSelectedPokers()
                if(!self.isSameIndex(selectedData.real_selected_codeList)){
                    selectedData.real_selected_pokerList.sort(function(a, b){
                        return b.selected_time - a.selected_time
                    })
                    let need_select_codeList = self.getAllSameIndexCodeList(mySeatInfo.cards, selectedData.real_selected_pokerList[0].code)
                    if(need_select_codeList.length > 0){
                        self.view.mySeatCards.selectPokers(need_select_codeList, null)
                    }
                }else{
                    if(selectedData.real_selected_codeList.length == 0){
                        self.view.mySeatCards.selectPokers(lastSelectData.real_selected_codeList, null)
                    }else{

                    }                    
                }
                self.view.mySeatCards.refreshPokerSelectState(false)
            }else if(self.m_can_follow_code_list.length > 0){
                let selectedData = self.view.mySeatCards.getSelectedPokers()                
                let real_selected_codeList = selectedData.real_selected_codeList
                let need_select_codeList = []
                for (let index = 0; index < real_selected_codeList.length; index++) {
                    const code = real_selected_codeList[index];
                    if(self.m_can_follow_code_list.indexOf(code) >= 0){
                        need_select_codeList.push(code)
                    }
                }
                if(need_select_codeList.length > 0){
                    self.view.mySeatCards.selectPokers(need_select_codeList, null)                    
                }else{
                    self.view.mySeatCards.selectPokers(lastSelectData.real_selected_codeList, null)
                }
                self.view.mySeatCards.refreshPokerSelectState(false)
            }
        }        
    }

    protected initTableData(protoData: BiPaiGame.IGameInfo){
        let self = this
        let roomInfo = new BiPaiRoomInfo()        
        roomInfo.ruleTable = self.getRemoteRule()
        roomInfo.maxPlayerCount = protoData.maxPlayerCnt
        roomInfo.playerCount = protoData.seatList.length
        roomInfo.discardSeatId = protoData.discardSeatId
        roomInfo.bankerSeatId = protoData.bankerSeatId        
        roomInfo.state = protoData.state
        roomInfo.stateExpiredTime = protoData.stateExpiredTime
        roomInfo.stateDuration = protoData.stateDuration
        roomInfo.currentSeat = protoData.currentSeat
        roomInfo.timeOffset = protoData.time - Utility.nowTimestamp()
        roomInfo.isRoundStarted = protoData.state != 0
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        self.view.setSeatCount(roomInfo.maxPlayerCount)
        roomInfo.roundCount = roomInfo.ruleTable.roundCount
        roomInfo.isGoldTable = ModelData.instance.tableCommonData.tableType == 1
        let seatInfoList = []
        roomInfo.seatInfoList = seatInfoList
        for (let index = 1; index <= protoData.maxPlayerCnt; index++) {
            let element: any = {
                seatId: index,
                playerId: 0,
                coinBalance: 0,
                cards: [],
                cardPoint: 0,
                discardCards: [],
                isPlaying: false
            }
            for (let i = 0; i < protoData.seatList.length; i++) {
                const tmp = protoData.seatList[i];
                if(tmp.seatId == index){
                    element = tmp
                    UserDataManager.setUserJsonData(tmp.userJson)
                    break
                }
            }
            let seatInfo = self.genSeatInfo(element.playerId)
            seatInfo.remotePos = element.seatId
            seatInfo.isBanker = roomInfo.bankerSeatId == seatInfo.remotePos
            seatInfo.isPlaying = element.isPlaying
            seatInfo.coinBalance = element.coinBalance
            seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, seatInfo.coinBalance)
            seatInfo.cards = element.cards
            self.sortCodeListByIndex(seatInfo.cards)
            seatInfo.cardPoint = element.cardPoint
            seatInfo.discards_list = []
            for (let i = 0; i < element.discardCards.length; i++) {
                const discards = element.discardCards[i];
                seatInfo.discards_list.push(discards.cards)
            }
            if (self.isMySelf(seatInfo.playerId)) {
                roomInfo.mySeatInfo = seatInfo
            }
            seatInfoList.push(seatInfo)
        }

        for (let i = 0; i < seatInfoList.length; i++) {
            const seatInfo = seatInfoList[i];
            seatInfo.localPos = self.getLocalPosFromRemotePos(seatInfo.remotePos, roomInfo.mySeatInfo.remotePos, roomInfo.maxPlayerCount)
        }
        if(protoData.state == 0 || protoData.state == 5){   //未开始之前，或者结算状态
            roomInfo.currentSeat = 0
            roomInfo.discardSeatId = 0
        }
        self.setIsGoldTable(true || ModelData.instance.tableCommonData.tableType == 1)
        self.setIsMatchTable(ModelData.instance.tableCommonData.tableType == 2)        
        self.setRoomInfo(roomInfo)
    }

    protected onNetMsg_LeaveNotify(protoData){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let seatInfoList = roomInfo.seatInfoList
        let lastCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index];
            if(seatInfo.playerId){
                lastCount++
            }
        }
        let mySeatInfo = this.getRoomInfo().mySeatInfo
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId) as BiPaiSeatInfo
        seatInfo.isPlaying = false
        seatInfo.cards = []
        seatInfo.cardPoint = 0
        seatInfo.discards_list = []
        let localPos = seatInfo.localPos
        
        this.view.showSeatPiaoFen(seatInfo.localPos, false)        
        this.view.showSeatHandCards(seatInfo.localPos, false)
        if(mySeatInfo.playerId == seatInfo.playerId){
            if (joinUtil.checkLeave(protoData.reason,this)) {
                roomInfo.state = 0
                this.showWaitStartSecsPanel(false, 0)
                this.closeServerConnect()
                return
            }
        }
        super.onNetMsg_LeaveNotify(protoData)        
        if (mySeatInfo.playerId == seatInfo.playerId) {
            return
        }
        this.view.getSeatViewByPos(localPos).showNoSeatDown(false)
        if(roomInfo.state == 0){
            if(lastCount >= roomInfo.ruleTable.pub_MinPlayerNum){
                let inCount = 0
                for (let index = 0; index < seatInfoList.length; index++) {
                    const seatInfo = seatInfoList[index];
                    if(seatInfo.playerId){
                        inCount++
                    }
                }
                if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){      
                    this.showWaitStartSecsPanel(true, 1)
                }
            }
        }
    }

    protected onNetMsg_EnterNotify(protoData: Room.EnterBroadcast){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let seatInfoList = roomInfo.seatInfoList
        let lastCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index];
            if(seatInfo.playerId){
                lastCount++
            }
        }
        super.onNetMsg_EnterNotify(protoData)
        let seatInfo = this.getSeatInfoByRemotePos(protoData.posInfo.posIndex) as BiPaiSeatInfo
        seatInfo.isPlaying = false
        seatInfo.coinBalance = protoData.posInfo.coinBalance
        this.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)

        this.view.bindSeatDispatchCardsUid(seatInfo.localPos, seatInfo.playerId)
        this.view.bindSeatHandCardsUid(seatInfo.localPos, seatInfo.playerId)
        this.view.bindSeatMingHandCardsUid(seatInfo.localPos, seatInfo.playerId)

        let inCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as BiPaiSeatInfo
            if(seatInfo.playerId){
                inCount++
                this.view.showSeatWatchTag(seatInfo.localPos, !seatInfo.isPlaying && roomInfo.state != 0 && roomInfo.state != 5)
            }
        }
        if(roomInfo.state == 0 || roomInfo.state == 5){
            if(lastCount < roomInfo.ruleTable.pub_MinPlayerNum){                
                if(inCount >= roomInfo.ruleTable.pub_MinPlayerNum){
                    this.showWaitStartSecsPanel(true, 4)
                }
            }
            
        }
    }

    protected onNetMsg_BankerNotify(protoData: BiPaiGame.IBankerNotify) {
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        roomInfo.state = 1
        roomInfo.isRoundStarted = true
        roomInfo.bankerSeatId = protoData.seatId
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as BiPaiSeatInfo
        seatInfo.isBanker = true
        let seatInfoList = roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index] as BiPaiSeatInfo
            if(element.playerId){
                element.isPlaying = true
            }
        }
        self.view.playSetBankerAnim(seatInfo.localPos)
        self.showWaitStartSecsPanel(false)
        this.eventDispatch('Game_Table_Start');
        this.view.showRecordLabel(true, protoData.roundSign)
    }

    protected onNetMsg_DealCardNotify(protoData: BiPaiGame.IDealCardNotify) {
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        self.view.showPokerHeap(roomInfo.isRoundStarted, roomInfo.pokerHeapCount)
        let mySeatInfo = roomInfo.mySeatInfo
        let cardsCount = 0
        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as BiPaiSeatInfo
            seatInfo.cards = element.cards
            self.sortCodeListByIndex(seatInfo.cards)
            seatInfo.cardPoint = element.cardPoint
            cardsCount += seatInfo.cards.length
        }

        let do_funs = []
        let tmpSeatList = self.getSeatInfoListFromTargetSeat(roomInfo.bankerSeatId)

        let maxCount = 5
        let count = tmpSeatList.length
        let duration = const_fapai_duration
        let interval = tmpSeatList.length * const_fapai_single_interval * (maxCount / count)
        let delay = const_fapai_seat_interval * (maxCount / count)
        let leftPokerCount = roomInfo.pokerHeapCount + cardsCount
        for (let index = 0; index < tmpSeatList.length; index++) {
            const seatInfo = tmpSeatList[index] as BiPaiSeatInfo
            let tmp_fun = function(cb){
                if(seatInfo == mySeatInfo){
                    self.view.mySeatCards.playFaPaiAnim(seatInfo.cards, seatInfo.cardPoint, duration, interval, index * delay, cb, function(tmpIndex){
                        self.m_table_sound.playDealCardEffectSound()
                        leftPokerCount--
                        self.view.showPokerHeap(true, leftPokerCount)
                    }, cc.easeCubicActionOut())
                }else{
                    self.view.playSeatFaPaiAnim(seatInfo.localPos, seatInfo.cards, duration, interval, index * delay, cb, function(tmpIndex){
                        self.m_table_sound.playDealCardEffectSound()
                        leftPokerCount--
                        self.view.showPokerHeap(true, leftPokerCount)
                    })
                }                
            }            
            do_funs.push(tmp_fun)
        }
        
        self.m_is_playing_fapai_anim = true
        let ackId = self.m_ack_id
        PromiseUtility.all(do_funs).then(function(){
            self.send_ack(ackId)
            self.m_is_playing_fapai_anim = false
            self.view.showPokerHeap(true, roomInfo.pokerHeapCount)
            self.view.showFollowMultiple(roomInfo.ruleTable.game_EnableFollowRate, 0)
        })
    }

    protected onNetMsg_MoreCardRsp(protoData: BiPaiGame.IMoreCardRsp) {
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)         
            return
        }
        this.view.showOpenCardBtn(false)
        this.view.showMoreCardBtn(false)
        this.view.showFollowBtn(false)
        this.view.showDiscardBtn(false)
    }
    protected onNetMsg_MoreCardNotify(protoData: BiPaiGame.IMoreCardNotify) {
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo
        let seatInfo = this.getSeatInfoByRemotePos(protoData.seatId) as BiPaiSeatInfo
        seatInfo.cards.push(protoData.card)
        seatInfo.cardPoint = protoData.cardPoint
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        self.view.showPokerHeap(true, roomInfo.pokerHeapCount)
        self.sortCodeListByIndex(seatInfo.cards)
        let duration = const_mopai_duration
        roomInfo.discardSeatId = seatInfo.remotePos
        self.m_table_sound.playTakeCardEffectSound()
        let ackId = self.m_ack_id
        if(this.isMySelf(seatInfo.playerId)){     
            self.view.showMoreCardBtn(false)
            self.view.showOpenCardBtn(false)
            self.view.showFollowBtn(false)
            self.m_is_playing_fapai_anim = true                   
            self.view.mySeatCards.playMoPaiAnim(protoData.card, seatInfo.cards, seatInfo.cardPoint, duration, 0, true, function(){
                self.send_ack(ackId)
                self.m_is_playing_fapai_anim = false
            }, null, cc.easeCubicActionOut())
        }else{
            self.view.playSeatMoPaiAnim(seatInfo.localPos, protoData.card, seatInfo.cards, duration, function(){
                self.send_ack(ackId)
            })
        }
    }
    protected onNetMsg_OpenCardRsp(protoData: BiPaiGame.IOpenCardRsp) {
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)         
            return
        }
        this.view.showOpenCardBtn(false)
        this.view.showMoreCardBtn(false)
        this.view.showFollowBtn(false)
    }

    protected onNetMsg_SysOpenRsp(protoData: BiPaiGame.ISysOpenRsp) {
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        this.view.showOpenCardBtn(false)
        this.view.showSystemOpenBtn(false)
        this.view.showFollowBtn(false)
    }

    protected onNetMsg_DiscardRsp(protoData: BiPaiGame.IDiscardRsp) {
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        this.view.showDiscardBtn(false)
    }
    protected onNetMsg_DiscardNotify(protoData: BiPaiGame.IDiscardNotify) {
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        self.view.showPokerHeap(true, roomInfo.pokerHeapCount)
        roomInfo.discardSeatId = protoData.seatId
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as BiPaiSeatInfo
        self.view.showSeatClock(seatInfo.localPos, false)
        self.sortCodeListByIndex(protoData.card)        
        seatInfo.cardPoint = protoData.cardPoint        
        seatInfo.discards_list.push(protoData.card)
        if(self.isMySelf(seatInfo.playerId)){
            self.view.showDiscardBtn(false)
        }
        let do_funs = []
        let cleanDelay = const_discard_duraton * 0.29
        if(roomInfo.bankerSeatId == protoData.seatId){
            //清除所有牌桌上出的牌
            let duration = const_recycle_duration
            let interval = const_recycle_interval
            let delay = const_recycle_seat_interval
            let tmpList = self.getSeatInfoListFromTargetSeat(roomInfo.bankerSeatId)
            let index = 0
            for (let i = 0; i < tmpList.length; i++) {
                const element = tmpList[i] as BiPaiSeatInfo
                if(element.playerId){
                    if(i == 0){
                        if(element.discards_list.length > 1){
                            element.discards_list.shift()
                            let tmpIndex = index
                            let tmpFun = function(cb){                                                    
                                self.view.playRecycleDispatchCards(element.localPos, false, duration, interval, cleanDelay + delay * tmpIndex, cb)
                            } 
                            self.view.setSeatDispatchCardsLastIndex(element.localPos)
                            index++
                            do_funs.push(tmpFun) 
                        }
                    }else{
                        element.discards_list = []
                        let tmpIndex = index
                        let tmpFun = function(cb){                                                    
                            self.view.playRecycleDispatchCards(element.localPos, true, duration, interval, cleanDelay + delay * tmpIndex, cb)
                        } 
                        self.view.setSeatDispatchCardsLastIndex(element.localPos)
                        index++
                        do_funs.push(tmpFun) 
                    }                    
                }                            
            }
        }
        //播放出牌动画            
        let tmpFun = function(cb){
            if(self.isMySelf(seatInfo.playerId)){
                if(self.codeListContans(seatInfo.cards, protoData.card)){
                    self.playMyDiscardsAnim(seatInfo, protoData.card, const_discard_duraton, cb)             
                }                
            }else{
                self.playDiscardsAnim(seatInfo, protoData.card, const_discard_duraton)   
            }
            
        }
        do_funs.push(tmpFun)
        self.m_table_sound.playPutCardEffectSound()
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        let cardName = Card.codeToIndex(protoData.card[0])
        self.m_table_sound.playCardTypeSound(isMale, protoData.card.length, cardName)
        PromiseUtility.all(do_funs).then(function(){
            
        })
        let ackId = self.m_ack_id
        self.scheduleOnce(function(){
            self.send_ack(ackId)
        }, 0.5)        
    }
    protected onNetMsg_FollowRsp(protoData: BiPaiGame.IFollowRsp) {
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo) 
            GameServer.instance.heartbeat_timeout_reconnect()        
            return
        }
        this.view.showFollowBtn(false)
        this.view.showMoreCardBtn(false)
        this.view.showOpenCardBtn(false)
    }
    protected onNetMsg_FollowNotify(protoData: BiPaiGame.IFollowNotify) {
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        let seatInfoList = self.getSeatInfoListFromTargetSeat(protoData.seatId)
        roomInfo.discardSeatId = protoData.discardSeatId
        let discardSeatInfo = self.getSeatInfoByRemotePos(roomInfo.discardSeatId) as BiPaiSeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as BiPaiSeatInfo
        seatInfo.cardPoint = protoData.cardPoint
        seatInfo.discards_list.push(protoData.card)
        if(self.isMySelf(seatInfo.playerId)){
            self.view.showMoreCardBtn(false)
            self.view.showOpenCardBtn(false)
            self.view.showFollowBtn(false)
        }
        let do_funs = []
        let cleanDelay = const_discard_duraton * 0.3
        if(roomInfo.bankerSeatId == protoData.seatId){            
            //清除除跟牌以外的牌
            let keepSeatIdList = self.getSeatIdsBetween(protoData.discardSeatId, protoData.seatId)
            let index = 0
            let duration = const_recycle_duration
            let interval = const_recycle_interval
            let delay = const_recycle_seat_interval
            for (let i = 0; i < seatInfoList.length; i++) {
                const element = seatInfoList[i] as BiPaiSeatInfo
                if(element.playerId){
                    let tmpIndex = index
                    if(keepSeatIdList.indexOf(element.remotePos) >= 0){
                        if(element.discards_list.length > 1){
                            element.discards_list.shift()
                            do_funs.push(function(cb){self.view.playRecycleDispatchCards(element.localPos, false, duration, interval, cleanDelay + delay * tmpIndex, cb)})    
                            index++
                        }                                                                    
                    }else{
                        element.discards_list = []
                        do_funs.push(function(cb){self.view.playRecycleDispatchCards(element.localPos, true, duration, interval, cleanDelay + delay * tmpIndex, cb)})     
                        index++
                    }
                    self.view.setSeatDispatchCardsLastIndex(element.localPos)
                }
            }
        }
        //播放跟牌动画            
        let tmpFun = function(cb){
            self.sortCodeListByIndex(protoData.card)
            if(self.isMySelf(seatInfo.playerId)){                
                if(self.codeListContans(seatInfo.cards, protoData.card)){
                    self.playMyDiscardsAnim(seatInfo, protoData.card, const_discard_duraton, cb)             
                }             
            }else{
                self.playDiscardsAnim(seatInfo, protoData.card, const_discard_duraton, cb)   
            }
            self.view.playSeatGenPaiAnim(seatInfo.localPos, protoData.card.length, const_discard_duraton * 0.16)

            self.m_table_sound.playRollBombSound()
            discardSeatInfo.coinBalance = protoData.losserCoinBalance
            discardSeatInfo.playerId && UserDataManager.setUserGameTableCurrency(discardSeatInfo.playerId, discardSeatInfo.coinBalance)

            seatInfo.coinBalance = protoData.winnerCoinBalance
            seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, seatInfo.coinBalance)

            self.view.playFlyBombAnim(discardSeatInfo.localPos, seatInfo.localPos, function(){                
                self.m_table_sound.playGunBombEffectSound()
                self.view.playSeatBombAnim(discardSeatInfo.localPos)
                self.scheduleOnce(function(){
                    if(roomInfo.ruleTable.game_EnableFollowRate){                    
                        self.view.playFollowMultipleChangeAnim(function(){
                            self.view.showFollowMultiple(true, protoData.followRate)
                        })
                    }
                }, 0.2)
                self.view.playGoldFlyAnim(discardSeatInfo.localPos, seatInfo.localPos, const_gold_fly_duration, function(){
                    self.view.showSeatPiaoFen(discardSeatInfo.localPos, true, -protoData.bombCoin)
                    self.view.showSeatCoinBalance(discardSeatInfo.localPos, true, discardSeatInfo.coinBalance)
                    self.view.showSeatPiaoFen(seatInfo.localPos, true, protoData.bombCoin)
                    self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
                }, 7, 0.05, const_discard_duraton * 0.25 + 0.5 * 0.6)
                self.scheduleOnce(function(){
                    self.m_table_sound.playGoldFlyEffectSound()
                }, const_gold_fly_duration) 
                self.view.showSeatGoldAnim(seatInfo.localPos, true, const_discard_duraton * 0.25 + 0.5 * 0.6 + const_gold_fly_duration * 1.1)
            })            
        }
        do_funs.push(tmpFun)
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        self.m_table_sound.playFollowSound(isMale, protoData.card.length)
        PromiseUtility.all(do_funs).then(function(){
            
        })
        let ackId = self.m_ack_id
        self.scheduleOnce(function(){
            self.send_ack(ackId)
        }, 0.5) 
        if(self.isLocalSeatPosSequence(protoData.seatId, mySeatInfo.remotePos, roomInfo.maxPlayerCount)){
            if(roomInfo.discardSeatId == mySeatInfo.remotePos){
                roomInfo.discardSeatId = 0
            }
        }
    }
    protected onNetMsg_GameSettle(protoData: BiPaiGame.IGameSettle) {
        let self = this
        self.m_need_show_assistant = false
        self.m_assistant_rate = 0
        // self.closeServerConnect()
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()   
        roomInfo.state = 5
        roomInfo.currentSeat = 0
        roomInfo.discardSeatId = 0
        roomInfo.bankerSeatId = 0
        roomInfo.pokerHeapCount = 0
        roomInfo.isRoundStarted = false
        let seatInfoList = roomInfo.seatInfoList
        let mySeatInfo = roomInfo.mySeatInfo as BiPaiSeatInfo  
        let selfIsPlaying = mySeatInfo.isPlaying
        // self.view.showFollowBtn(false)
        // self.view.showDiscardBtn(false)
        // self.view.showOpenCardBtn(false)
        // self.view.showMoreCardBtn(false)
        // self.view.showSystemOpenBtn(false)
        let ackId = self.m_ack_id
        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            if(element.seatId == mySeatInfo.remotePos){
                UserDataManager.balanceChangeMessage(element.coinBalance)
            }
            let seatInfo = this.getSeatInfoByPlayerId(element.playerId) as BiPaiSeatInfo
            seatInfo.coinBalance = element.coinBalance
            seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, seatInfo.coinBalance)
            seatInfo.cards = []
            seatInfo.cardPoint = 0
            seatInfo.discards_list = []
            seatInfo.isPlaying = false            
            this.view.showSeatClock(seatInfo.localPos, false)
        }

        if(!selfIsPlaying){
            for (let index = 0; index < seatInfoList.length; index++) {
                const seatInfo = seatInfoList[index] as BiPaiSeatInfo
                if(seatInfo.playerId){
                    self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
                }
            }
            self.cleanDesk()
            self.showWaitStartSecsPanel(true, 2)
            self.send_ack(self.m_ack_id)
            return
        }
        let find_seatSettle = function(seatId){
            for (let index = 0; index < protoData.seatList.length; index++) {
                const element = protoData.seatList[index];
                if(element.seatId == seatId){
                    return element
                }
            }
        }

        let is_seatWin = function(seatId){
            for (let index = 0; index < protoData.winnerSeatList.length; index++) {
                const element = protoData.winnerSeatList[index];
                if(element == seatId){
                    return true
                }
            }
            return false
        }

        let rateData
        let showResultPanel = function(){
            for (let index = 0; index < seatInfoList.length; index++) {
                const seatInfo = seatInfoList[index] as BiPaiSeatInfo
                if(seatInfo.playerId){
                    self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
                }
            }
            let intentData: BiPaiGoldGameResultData = {
                backBtnCallback: function(){
                    // self.onLeaveRoomSuccess()
                    self.model.send_leave_request()
                },
                continueBtnCallback: function(){      
                    
                    
                    // let goldId =  ModelData.instance.tableCommonData.goldFildId;
                    // if (joinUtil.checkLeave(-888,goldId,self)) {
                        
                    //     ModuleManager.instance.hideModule("BiPaiGoldOneGameResultModule");
                        
                    // }else{
                    //     SceneManager.loadingTableModule(null,()=>{
                    //         HallServer.instance.start_enter_gold_matching(goldId);
                    //     });
                    // }     
                    ModuleManager.instance.hideModule("BiPaiGoldOneGameResultModule");
                    self.send_ack(self.m_ack_id)
                    if(roomInfo.state == 5){
                        self.cleanDesk()
                        roomInfo.state = 0
                        let inCount = 0
                        for (let index = 0; index < seatInfoList.length; index++) {
                            const seatInfo = seatInfoList[index];
                            if(seatInfo.playerId){
                                inCount++
                            }
                        }
                        if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){
                            self.showWaitStartSecsPanel(true, 1)
                        }else{
                            self.showWaitStartSecsPanel(true, 4)
                        }       
                        
                    }
                    if(self.isAutoLeaveOnEnd()){
                        self.setAutoLeaveOnEnd(false)
                        self.model.send_leave_request()
                        return
                    }                                
                },
                isWin: rateData.balance + rateData.bombBalance >= 0,
                score: rateData.balance + rateData.bombBalance,
            }
            intentData.openingMultiple = rateData.calcRates[0]
            intentData.followMultiple = rateData.calcRates[1]
            intentData.firstOpenMultiple = rateData.calcRates[2]
            intentData.normalOpenMultiple = rateData.calcRates[3]
            intentData.specailOpenMultiple = rateData.calcRates[4]
            intentData.ziMoMultiple = rateData.calcRates[5]
            intentData.fangPaoMultiple = rateData.calcRates[6]
            intentData.roundScore = rateData.balance
            intentData.followScore = rateData.bombBalance           
            if(intentData.isWin){
                self.m_table_sound.playCompareWinEffectSound()
            }else{
                self.m_table_sound.playCompareLoseEffectSound()
            }
            ModuleManager.instance.hideModule('GameMorePanel')
            self.eventDispatch("Game_Table_Settlement", self.getSeatNodeById(mySeatInfo.playerId))
            ModuleManager.instance.showModule(BiPaiGoldOneGameResultModule, intentData)
            self.send_ack(ackId)
        }

        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            self.sortCodeListByIndex(element.cards)
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as BiPaiSeatInfo
            seatInfo.coinBalance = element.coinBalance
            seatInfo.cards = element.cards
            seatInfo.cardPoint = element.cardPoint
            if(self.isMySelf(element.playerId)){
                rateData = element
            }
        }

        if(protoData.reason == 1){  //特殊牌型
            self.playOpeningResult(protoData, is_seatWin, find_seatSettle, showResultPanel)
        }else if(protoData.reason == 2 || protoData.reason == 3){    //玩家开牌
            self.playResultKaiPai(protoData, is_seatWin, find_seatSettle, true, showResultPanel)
        }else if(protoData.reason == 4){    //胡牌
            let triggerSeatInfo = self.getSeatInfoByRemotePos(protoData.triggerSeat)
            self.m_table_sound.playBombEffectSound()
            self.view.showFangPaoAnim(triggerSeatInfo.localPos, true, function(){
                let winSeatInfo = self.getSeatInfoByRemotePos(protoData.winnerSeatList[0])
                self.view.showJiePaoWenZiAnim(winSeatInfo.localPos, true, function(){
                    self.playResultKaiPai(protoData, is_seatWin, find_seatSettle, false, showResultPanel)
                })
                if(winSeatInfo == mySeatInfo){
                    self.view.mySeatCards.showResult(false)
                }
            })                        
        }else if(protoData.reason == 5){    //自摸
            self.m_table_sound.playPlaneFlyEffectSound()
            self.view.playFeiJiAnim(function(){
                let winSeatInfo = self.getSeatInfoByRemotePos(protoData.winnerSeatList[0])
                self.view.showZiMoWenZiAnim(winSeatInfo.localPos, true, function(){
                    self.playResultKaiPai(protoData, is_seatWin, find_seatSettle, false, showResultPanel)
                })
                if(winSeatInfo == mySeatInfo){
                    self.view.mySeatCards.showResult(false)
                }
            })            
        }else if(protoData.reason == 6){    //牌已经摸完
            self.playResultKaiPai(protoData, is_seatWin, find_seatSettle, false, showResultPanel)
        }else if(protoData.reason == 7){    //炸弹
            //播放炸弹
            self.playResultZhaDan(protoData, is_seatWin, find_seatSettle, showResultPanel)
            return
        }else{

        }        
    }

    protected onNetMsg_CardReocrderNotify(protoData: BiPaiGame.ICardReocrderNotify){
        let dataList = []
        let dataMap = {}
        for (let index = 0; index < protoData.cards.length; index++) {
            const code = protoData.cards[index];
            let card = Card.makeCardByCode(code)
            let d = dataMap[card.index] || {point: card.index, count: 0, colorCountList: [0, 0, 0, 0]}
            d.count++
            d.colorCountList[card.color - 1]++
            dataMap[card.index] = d
        }
        for (const key in dataMap) {
            if (dataMap.hasOwnProperty(key)) {
                const element = dataMap[key];
                dataList.push(element)
            }
        }
        this.view.refreshPokerRecorder({dataList: dataList})        
        this.view.showPokerRecorder(true, !this.m_has_show_recorder)
        this.m_has_show_recorder = true
    }

    protected onNetMsg_TimeoutNotify(protoData: BiPaiGame.ITimeoutNotify) {
        let self = this
        if(protoData.event == 888){
            this.m_ack_id = protoData.ackId
            return
        }
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let lastRoomState = roomInfo.state
        roomInfo.state = protoData.event
        if(roomInfo.state == 0){
            self.showWaitStartSecsPanel(true, protoData.timeout != 0? 3: 0, protoData.timeout)
            self.cleanDesk()
            ModuleManager.instance.hideModule("BiPaiGoldOneGameResultModule");
            if(lastRoomState == 5 && self.isAutoLeaveOnEnd()){
                self.setAutoLeaveOnEnd(false)
                self.model.send_leave_request()
                return
            }  
            return
        }
        let seatInfoList = roomInfo.seatInfoList
        let mySeatInfo = roomInfo.mySeatInfo
        roomInfo.currentSeat = protoData.seatId
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as BiPaiSeatInfo
            self.view.showSeatClock(seatInfo.localPos, seatInfo.remotePos == roomInfo.currentSeat, protoData.timeout, seatInfo == mySeatInfo, null, function(leftSecs){
                if(leftSecs <= 3){
                    self.m_table_sound.playClockTickEffectSound()
                }                
            })
        }
        if(roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId != mySeatInfo.remotePos){
            self.m_table_sound.playMyTurnEffectSound()
        }
        self.refreshBtns()
    }

    protected onNetMsg_Assistant(protoData: BiPaiGame.IAssistant){
        this.m_need_show_assistant = true
        this.m_assistant_rate = protoData.winRate
        this.view.refreshOpenCardSuccessProgress(true, this.m_assistant_rate)
    }

    protected playResultZhaDan(protoData: BiPaiGame.IGameSettle, is_seatWin, find_seatSettle, onFinish?: Function){
        let self = this
        let triggerSeatInfo = self.getSeatInfoByRemotePos(protoData.triggerSeat) as BiPaiSeatInfo
        let winerSeatInfo = self.getSeatInfoByRemotePos(protoData.winnerSeatList[0]) as BiPaiSeatInfo
        self.view.playSeatBombAnim(triggerSeatInfo.localPos)
        self.m_table_sound.playGunBombEffectSound()
        let ackId = self.m_ack_id
        self.view.playGoldFlyAnim(triggerSeatInfo.localPos, winerSeatInfo.localPos, const_gold_fly_duration, function(){
            let winnerSettle = find_seatSettle(winerSeatInfo.remotePos)
            let triggerSettle = find_seatSettle(triggerSeatInfo.remotePos)
            self.view.showSeatPiaoFen(winerSeatInfo.localPos, true, winnerSettle.balance)
            self.view.showSeatPiaoFen(triggerSeatInfo.localPos, true, triggerSettle.balance)
            self.view.showSeatCoinBalance(winerSeatInfo.localPos, true, winerSeatInfo.coinBalance)
            self.view.showSeatCoinBalance(triggerSeatInfo.localPos, true, triggerSeatInfo.coinBalance)
            self.send_ack(ackId)
        }, 20, 0.03)

    }

    protected playOpeningResult(protoData: BiPaiGame.IGameSettle, is_seatWin, find_seatSettle, onFinish?: Function){
        let self = this
        let do_ming_funs = []
        let do_ming_funs1 = []
        let do_seat_win_effect_funs = []
        let do_seat_score_effect_funs = []
        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as BiPaiSeatInfo
            let tmpFun = function(cb){
                self.m_table_sound.playShowCardEffectSound()
                if(element.cardType == 2 || element.cardType == 6){
                    if(self.codeListContansIndex(seatInfo.cards, [CardNameIndex.card_10, CardNameIndex.card_A])){
                        self.sortCodeListByValue(seatInfo.cards)
                    }
                }
                self.playMingPaiAnim(seatInfo, true, false, function(){
                    self.playPaiXingAnim(seatInfo, element.cardType, element.cardValue, true, cb)                    
                })                
                if(seatInfo.localPos == 0){
                    self.view.mySeatCards.showPokers(false)
                }else{
                    self.view.showSeatHandCards(seatInfo.localPos, false)
                }                
            }
            if(element.cardType == 0){
                do_ming_funs1.push(tmpFun)
            }else{
                do_ming_funs.push(tmpFun)
            }
            
            if(is_seatWin(seatInfo.remotePos)){
                let tmpFun1 = function(cb){
                    self.view.showSeatWinEffect(seatInfo.localPos, true, cb)                
                }
                do_seat_win_effect_funs.push(tmpFun1)
            }
           
            let tmpFun2 = function(cb){
                self.view.showSeatScore(seatInfo.localPos, true, element.balance, function(){
                    self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
                    cb && cb()
                })
            }
            do_seat_score_effect_funs.push(tmpFun2)
        }


        PromiseUtility.all(do_ming_funs).then(function(){
            self.m_table_sound.playSpecialCardEffectSound()
            PromiseUtility.all(do_ming_funs1).then(function(){
                PromiseUtility.all(do_seat_win_effect_funs).then(function(){
                    PromiseUtility.all(do_seat_score_effect_funs).then(function(){
                        onFinish && onFinish()
                    })
                })
            })
        })
    }

    protected playResultKaiPai(protoData: BiPaiGame.IGameSettle, is_seatWin, find_seatSettle, isActiveOpen: boolean, onFinish?: Function){
        let self = this
        let triggerSeatInfo = self.getSeatInfoByRemotePos(protoData.triggerSeat)
        let mySeatInfo = self.getRoomInfo().mySeatInfo as BiPaiSeatInfo
        let do_ming_funs = []
        let do_recycle_funs = []
        let do_win_result_funs = []
        let do_seat_score_effect_funs = []
        let minPoint = Number.MAX_VALUE
        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            if(element.cardPoint < minPoint){
                minPoint = element.cardPoint
            }
        }

        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as BiPaiSeatInfo
            if(seatInfo != triggerSeatInfo){
                let tmpFun = function(cb){
                    if(seatInfo.localPos == 0){
                        self.view.mySeatCards.showPokers(false)
                    }else{
                        self.view.showSeatHandCards(seatInfo.localPos, false)
                    }
                    self.m_table_sound.playShowCardEffectSound()
                    self.playMingPaiAnim(seatInfo, false, !is_seatWin(seatInfo.remotePos), cb)
                }
                do_ming_funs.push(tmpFun)
            }
            do_win_result_funs.push(function(cb){
                let isWin = is_seatWin(seatInfo.remotePos)
                if(isWin){
                    self.view.showSeatWinEffect(seatInfo.localPos, true, cb)
                    if(seatInfo.cardPoint == minPoint){
                        self.view.showWinCardPointAnim(seatInfo.localPos, true, seatInfo.cardPoint, function(){
                            self.view.showSeatMingHandCardPoint(seatInfo.localPos, false, seatInfo.cardPoint)
                        })
                    }else{
                        self.view.showSeatMingHandCardPoint(seatInfo.localPos, true, seatInfo.cardPoint)
                    }
                    
                    (protoData.reason == 6 || isActiveOpen) && seatInfo.localPos != 0 && self.view.showMingWinAnim(seatInfo.localPos, true)
                }else{
                    self.view.showSeatMingHandCardPoint(seatInfo.localPos, true, seatInfo.cardPoint, true)
                    cb && cb()
                }
                if(seatInfo == triggerSeatInfo){
                    if(isWin){                        
                        
                    }else{                        
                        isActiveOpen && self.view.showKaiPaiLoseAnim(seatInfo.localPos, true)
                    }
                }                
            })
            do_seat_score_effect_funs.push(function(cb){
                self.view.showSeatScore(seatInfo.localPos, true, element.balance, function(){
                    self.view.showSeatCoinBalance(seatInfo.localPos, true, seatInfo.coinBalance)
                    cb && cb()
                })
            })
        }
        if(isActiveOpen){
            let isMale = triggerSeatInfo.userInfo && triggerSeatInfo.userInfo.gender == 1
            self.m_table_sound.playKaiSound(isMale)
            do_recycle_funs.push(function(cb){
                self.m_table_sound.playCompareCardEffectSound()
                self.view.showOpenCardAnim(triggerSeatInfo.localPos, true, cb)
            })
        }
        
        do_recycle_funs.push(function(cb){
            self.m_table_sound.playFlopCardEffectSound()
            self.playRecycleSeatDispatchedCards(protoData.triggerSeat, true, cb)
        }) 
        PromiseUtility.all(do_recycle_funs).then(function(){
            if(triggerSeatInfo.localPos == 0){
                self.view.mySeatCards.showPokers(false)
            }else{
                self.view.showSeatHandCards(triggerSeatInfo.localPos, false)
            }
            self.m_table_sound.playShowCardEffectSound()
            self.playMingPaiAnim(triggerSeatInfo, false, !is_seatWin(triggerSeatInfo.remotePos), function(){
                PromiseUtility.all(do_ming_funs).then(function(){
                    if(isActiveOpen){
                        if(protoData.triggerSeat == mySeatInfo.remotePos){
                            if(protoData.reason == 2){
                                
                            }else if(protoData.reason == 3){

                            }
                        }
                    }
                    PromiseUtility.all(do_win_result_funs).then(function(){
                        PromiseUtility.all(do_seat_score_effect_funs).then(function(){
                            onFinish && onFinish()
                        })
                    })
                })
            })           
        })            

    }    

    protected playPaiXingAnim(seatInfo: BiPaiSeatInfo, type: number, value: number, playSound?: boolean, onFinish?: Function){
        let self = this        
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        let localPos = seatInfo.localPos
        if(type == 6){
            if(value == 14){
                playSound && self.m_table_sound.playHuangJiaTongHuaShunSound(isMale)
                self.view.showHuangJiaTongHuaShunAnim(localPos, true, onFinish)
            }else{
                playSound && self.m_table_sound.playTongHuaShunSound(isMale)
                self.view.showTongHuaShunAnim(localPos, true, onFinish)
            }       
            return
        }else if(type == 4){
            playSound && self.m_table_sound.playHuLuSound(isMale)
            self.view.showHuLuAnim(localPos, true, onFinish)
            return
        }else if(type == 5){
            playSound && self.m_table_sound.playSiTiaoSound(isMale)
            self.view.showSiTiaoAnim(localPos, true, onFinish)
            return
        }else if(type == 2){
            playSound && self.m_table_sound.playShunZiSound(isMale)
            self.view.showShunZiAnim(localPos, true, onFinish)
            return
        }else if(type == 3){
            playSound && self.m_table_sound.playTongHuaSound(isMale)
            self.view.showTongHuaAnim(localPos, true, onFinish)
            return
        }else if(type == 1){
            playSound && self.m_table_sound.playSanTiaoSound(isMale)
            self.view.showSanTiaoAnim(localPos, true, onFinish)
            return
        }
        onFinish && onFinish()
    }

    protected playMingPaiAnim(seatInfo, hidePointNum, isGray, onFinish){
        let self = this
        let params: any= {
            playAnim: true,
            pointNum: seatInfo.cardPoint,
            onFinishPlayAnim: onFinish,
            hidePointNum: hidePointNum,
            isGray: false//isGray
        }
        self.view.showSeatMingHandCards(seatInfo.localPos, true, seatInfo.cards, params)
    }

    protected playRecycleSeatDispatchedCards(fromSeatId: number, isAll: boolean, onFinish: Function){
        let self = this
        let do_recycle_funs = []
        let tmpSeatInfoList = self.getSeatInfoListFromTargetSeat(fromSeatId)
        for (let index = 0; index < tmpSeatInfoList.length; index++) {
            const seatInfo = tmpSeatInfoList[index];
            let recycle_fun = function(cb){
                self.view.playRecycleDispatchCards(seatInfo.localPos, isAll, const_recycle_duration, const_recycle_interval, const_recycle_seat_interval * index, cb)
            }
            do_recycle_funs.push(recycle_fun)
        }
        if(do_recycle_funs.length == 0){
            onFinish && onFinish()
        }else{
            PromiseUtility.all(do_recycle_funs).then(function(){
                onFinish && onFinish()
            })
        }
    }

    // protected on_click_btn(event: cc.Button) {
    //     let self = this
    //     let isClickValid = Utility.btnClickValid(100)
    //     if (!isClickValid) {
    //         return isClickValid
    //     }
    //     Utility.playButtonSound()
    //     let node: cc.Node = event.node
    //     cc.log('on_click------------', node.name)
    //     if(node == self.view.buttonOpenCard.node){
    //         self.on_click_open_card_btn(node)
    //     }else if(node == self.view.buttonMoreCard.node){
    //         self.on_click_more_card_btn(node)
    //     }else if(node == self.view.buttonFollow.node){
    //         self.on_click_follow_btn(node)
    //     }else if(node == self.view.buttonDiscard.node){
    //         self.on_click_discard_btn(node)        
    //     }
    // }

    @bindButtonClickEvent('openBtn')
    protected on_click_open_card_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showOpenCardBtn(true, true)
        this.view.refreshOpenCardSuccessProgress(self.m_need_show_assistant, self.m_assistant_rate)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showOpenCardBtn(false)
            self.view.showMoreCardBtn(false)
            self.view.showFollowBtn(false)
        })
        this.model.send_open_card_req()        
    }

    @bindButtonClickEvent('moreBtn')
    protected on_click_more_card_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showMoreCardBtn(true, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showOpenCardBtn(false)
            self.view.showMoreCardBtn(false)
            self.view.showFollowBtn(false)
        })
        this.model.send_more_card_req()        
    }

    @bindButtonClickEvent('systemOpenBtn')
    protected on_click_system_open_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showSystemOpenBtn(true, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showOpenCardBtn(false)
            self.view.showSystemOpenBtn(false)
            self.view.showFollowBtn(false)
        })
        this.model.send_system_open_req()        
    }

    @bindButtonClickEvent('followBtn')
    protected on_click_follow_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showFollowBtn(true, false, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showOpenCardBtn(false)
            self.view.showMoreCardBtn(false)
            self.view.showFollowBtn(false)
        })
        let selectedData = this.view.mySeatCards.getSelectedPokers()
        if(selectedData.real_selected_codeList.length == 0){
            cc.error('on_click_follow_btn selectedData.real_selected_codeList.length == 0')
            return
        }
        this.model.send_follow_req(selectedData.real_selected_codeList)   
        
        let mySeatInfo = self.getRoomInfo().mySeatInfo as BiPaiSeatInfo        
        let cards = mySeatInfo.cards.concat()
        self.removeCodesFromList(cards, selectedData.real_selected_codeList)
        mySeatInfo.cardPoint = self.calcCardsSumPoint(cards)   
        self.playMyDiscardsAnim(mySeatInfo, selectedData.real_selected_codeList, const_discard_duraton)  
    }

    @bindButtonClickEvent('discardBtn')
    protected on_click_discard_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        let selectedData = this.view.mySeatCards.getSelectedPokers()
        if(selectedData.real_selected_codeList.length == 0){
            cc.error('on_click_discard_btn selectedData.real_selected_codeList.length == 0')
            return
        }
        self.view.showDiscardBtn(true, false, true)
        this.view.playDiscardBtnAnim(false, function(){
            self.view.showDiscardBtn(false)
        })
        this.model.send_discard_req(selectedData.real_selected_codeList)

        let mySeatInfo = self.getRoomInfo().mySeatInfo as BiPaiSeatInfo        
        let cards = mySeatInfo.cards.concat()
        self.removeCodesFromList(cards, selectedData.real_selected_codeList)
        mySeatInfo.cardPoint = self.calcCardsSumPoint(cards)   
        self.playMyDiscardsAnim(mySeatInfo, selectedData.real_selected_codeList, const_discard_duraton)    
    }

    @bindButtonClickEvent('matchLeaveBtn')
    protected on_click_match_leave_btn(node: cc.Node){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        if(roomInfo.state == 0 || roomInfo.state == 5){
            this.model.send_leave_request()
            return
        }
    }

    protected on_click_menu_leave_btn(node: cc.Node){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as BiPaiSeatInfo
        if(roomInfo.state == 0 || roomInfo.state == 5){
            this.model.send_leave_request()
            return
        }
        if(!mySeatInfo.isPlaying){
            this.model.send_leave_request()
            return
        }

        ModuleManager.instance.showModule(DialogLeave)
    }

    @bindButtonClickEvent('MoreBtn')
    protected on_click_more_btn(node: cc.Node){
        ModuleManager.instance.showModule(GameMorePanel)
    }



    protected refreshBtns(){
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as BiPaiSeatInfo
        if(roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId == mySeatInfo.remotePos){
            self.hint_cards(mySeatInfo.cards)
        }
        let selectedData = self.view.mySeatCards.getSelectedPokers()
        let selectedCodes = []
        if(roomInfo.currentSeat == mySeatInfo.remotePos){
            selectedCodes = selectedData.real_selected_codeList
        }
        let lastDiscardSeatInfo = self.getSeatInfoByRemotePos(roomInfo.discardSeatId) as BiPaiSeatInfo
        if(lastDiscardSeatInfo){                        
            if(roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId != mySeatInfo.remotePos){
                let lastDiscards = lastDiscardSeatInfo.discards_list[lastDiscardSeatInfo.discards_list.length - 1]
                self.m_can_follow_code_list = self.getAllSameIndexCodeList(mySeatInfo.cards, lastDiscards[0])
            }else{
                self.m_can_follow_code_list = []
            }            
            
            if(roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId != mySeatInfo.remotePos && self.m_can_follow_code_list.length > 0){
                self.view.mySeatCards.selectPokers(self.m_can_follow_code_list, null)
                self.view.mySeatCards.refreshPokerSelectState(false)
                selectedData = self.view.mySeatCards.getSelectedPokers()
                selectedCodes = selectedData.real_selected_codeList
            }
            self.view.showFollowBtn(roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId != mySeatInfo.remotePos && self.m_can_follow_code_list.length > 0, selectedCodes.length == 0)
        }else{
            self.m_can_follow_code_list = []
            self.view.showFollowBtn(false)
        }
        
        let showDiscardBtn = roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId == mySeatInfo.remotePos
        let showOpenCardBtn = roomInfo.currentSeat == mySeatInfo.remotePos && roomInfo.discardSeatId != mySeatInfo.remotePos
        let showMoreCardBtn = showOpenCardBtn && roomInfo.pokerHeapCount > 0
        let showSystemOpenBtn = showOpenCardBtn && roomInfo.pokerHeapCount == 0

        self.view.showDiscardBtn(showDiscardBtn, selectedCodes.length == 0, selectedCodes.length == 0)        
        self.view.showOpenCardBtn(showOpenCardBtn)
        if(showOpenCardBtn){
            this.view.refreshOpenCardSuccessProgress(self.m_need_show_assistant, self.m_assistant_rate)
        }
        self.view.showMoreCardBtn(showMoreCardBtn)
        self.view.showSystemOpenBtn(showSystemOpenBtn)
        if(showDiscardBtn){
            self.view.playDiscardBtnAnim(true)
        }else if(showOpenCardBtn){
            self.view.playBtnsFadeAnim(true)
        }        
    }

    protected hint_cards(codeList: number[]){
        let self = this
        let list = []
        let maxSum = 0
        let maxCount = 0
        for (let index = CardNameIndex.card_A; index <= CardNameIndex.card_K; index++) {
            let tmpList = self.getAllSameIndexCodeList(codeList, Card.colorIndexToCode(CardColor.color_black_heart, index))
            if(tmpList.length > 0){
                let tmpSum = Card.indexToLogicPoint(index) * tmpList.length
                if(maxSum < tmpSum){
                    maxSum = tmpSum
                    maxCount = tmpList.length
                    list = tmpList
                }else if(maxSum == tmpSum){
                    if(maxCount <= tmpList.length){
                        maxCount = tmpList.length
                        list = tmpList
                    }
                }
            }
        }
        if(list.length > 0){
            self.view.mySeatCards.selectPokers(list, null)
            self.view.mySeatCards.refreshPokerSelectState(false)
        }        
    }

    protected send_ack(ackId){
        ackId = ackId || this.m_ack_id
        this.model.send_ack_req(ackId)
    }

    protected isSameIndex(codeList: number[]){
        let indexName = null
        for (let index = 0; index < codeList.length; index++) {
            const c = codeList[index];
            let name = Card.codeToIndex(c)
            if(indexName != null && name != indexName){
                return false
            }
            indexName = name
        }
        return true
    }

    protected calcCardsSumPoint(codeList: number[]): number{
        let sum = 0
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            sum += Card.codeToLogicPoint(code)
        }
        return sum
    }

    protected getAllSameIndexCodeList(codeList: number[], code: number): number[]{
        let list = []
        for (let index = 0; index < codeList.length; index++) {
            const tmpCode = codeList[index];
            if(Card.codeToIndex(tmpCode) == Card.codeToIndex(code)){
                list.push(tmpCode)
            }
        }
        return list
    }

    protected codeListContans(codeList: number[], targets: number[]){
        for (let index = 0; index < targets.length; index++) {
            const code = targets[index];
            if(codeList.indexOf(code) < 0){
                return false
            }
        }
        return true
    }

    protected codeListContansIndex(codeList: number[], indexList: number[]){
        for (let i = 0; i < indexList.length; i++) {
            const indexName = indexList[i];
            let include = false
            for (let j = CardColor.color_black_heart; j <= CardColor.color_square; j++) {
                let code = Card.colorIndexToCode(j, indexName)
                if(codeList.indexOf(code) >= 0){
                    include = true
                    break
                }
            }
            if(!include){
                return false
            }
        }
        return true
    }

    protected removeCodesFromList(codeList: number[], targets: number[]){
        targets = targets.concat()
        for (let i = 0; i < codeList.length; ) {
            const code = codeList[i];
            let include = false
            for (let index = 0; index < targets.length; index++) {
                const element = targets[index];
                if(code == element){
                    include = true
                    targets.splice(index, 1)
                    break
                }
            }
            if(include){
                codeList.splice(i, 1)
            }else{
                i++
            }
        }
    }

    protected on_msg_err(errNo: number){

    }


    protected playMyDiscardsAnim(seatInfo: BiPaiSeatInfo, discards: number[], duration: number, onFinish?: Function){
        let self = this
        self.removeCodesFromList(seatInfo.cards, discards.concat())
        let selectPokers = self.view.mySeatCards.selectPokers(discards, null)
        let sumPos = cc.Vec2.ZERO
        for (let i = 0; i < selectPokers.length; i++) {
            const poker = selectPokers[i];
            sumPos = sumPos.add(poker.node.position)                
        }
        sumPos = sumPos.mul( 1 / selectPokers.length)
        let worldPos = selectPokers[0].node.parent.convertToWorldSpaceAR(sumPos)
        self.view.mySeatCards.removePokers(selectPokers)
        self.m_is_playing_fapai_anim = true
        self.view.mySeatCards.playAdjust(duration * 0.3, function(){
            self.view.mySeatCards.showPokers(true, seatInfo.cards, {pointNum: seatInfo.cardPoint})
            self.m_is_playing_fapai_anim = false
        })
        self.view.mySeatCards.showResult(true, seatInfo.cardPoint)
        self.view.playDispatchCard(seatInfo.localPos, discards, duration, worldPos, onFinish)    
    }

    protected playDiscardsAnim(seatInfo: BiPaiSeatInfo, discards: number[], duration: number, onFinish?: Function){
        let self = this
        let params :any= {
            playAdjustAnim: true,
            targetLayoutCount: seatInfo.cards.length,
            duration: 0.8
        }
        seatInfo.cards.splice(0, discards.length)            
        self.view.showSeatHandCards(seatInfo.localPos, true, seatInfo.cards, params)
        self.view.playDispatchCard(seatInfo.localPos, discards, duration, null, onFinish)
    }

    protected getSeatInfoListFromTargetSeat(targetSeatId){
        let self = this
        let roomInfo = self.getRoomInfo<BiPaiRoomInfo>()
        let tmpList = roomInfo.seatInfoList.concat()
        for (let index = 0; index < tmpList.length; ) {
            const element = tmpList[index];
            if(element.playerId == 0){
                tmpList.splice(index, 1)                
            }else{
                index++
            }            
        }
        tmpList.sort(function(a, b){
            let aTmpPos = self.getLocalPosFromRemotePos(a.remotePos, targetSeatId, roomInfo.maxPlayerCount)
            let bTmpPos = self.getLocalPosFromRemotePos(b.remotePos, targetSeatId, roomInfo.maxPlayerCount)
            return aTmpPos - bTmpPos
        })
        return tmpList
    }

    protected isLocalSeatPosSequence(pos1: number, pos2: number, maxPlayerCount: number){   
        if(pos1 == pos2){
            return false
        }
        let count = pos2 - pos1 - 1
        if(pos1 > pos2){
            count = pos2 + maxPlayerCount - pos1 - 1
        }
        for (let index = 1; index <= count; index++) {
            let pos = (pos1 - 1 + index) % maxPlayerCount            
            let tmpSeatInfo = this.getSeatInfoByRemotePos(pos + 1)                        
            if(tmpSeatInfo && tmpSeatInfo.playerId != 0){
                return false
            }
        }
        return true
    }

    protected getSeatIdsBetween(from: number, to: number){
        let self = this
        let list = []
        let roomInfo = this.getRoomInfo<BiPaiRoomInfo>()
        let maxPlayerCount = roomInfo.maxPlayerCount
        for (let index = 1; index <= maxPlayerCount; index++) {
            if(from == index || index == to){
                list.push(index)
                continue
            }
            if(from < to){
                if(index > from && index < to){
                    let tmpSeatInfo = self.getSeatInfoByRemotePos(index)
                    if(tmpSeatInfo && tmpSeatInfo.playerId != 0){
                        list.push(index)
                        continue
                    }                    
                }
            }else{
                if(index > from || index < to){
                    let tmpSeatInfo = self.getSeatInfoByRemotePos(index)
                    if(tmpSeatInfo && tmpSeatInfo.playerId != 0){
                        list.push(index)
                        continue
                    } 
                }
            } 
        }
        return list
    }

    protected sortCodeListByIndex(codeList: number[]){
        codeList.sort(function(a, b){
            let aIndex = Card.codeToIndex(a)
            let bIndex = Card.codeToIndex(b)
            if(aIndex == bIndex){
                let aColor = Card.codeToColor(a)
                let bColor = Card.codeToColor(b)
                return aColor - bColor
            }
            return aIndex - bIndex
        })
    }

    protected sortCodeListByValue(codeList: number[]){
        codeList.sort(function(a, b){
            let aVal = Card.codeToValue(a)
            let bVal = Card.codeToValue(b)
            if(aVal == bVal){
                let aColor = Card.codeToColor(a)
                let bColor = Card.codeToColor(b)
                return aColor - bColor
            }
            return aVal - bVal
        })
    }

    onLeaveRoomSuccess(isKick?: boolean) {
        //断开连接
        this.closeServerConnect()
        //回到大厅界面
        SceneManager.gotoHallOrClubHall("TabelExit");               
    }

    protected showWaitStartSecsPanel(show: boolean, state?: number, secs?: number){
        this.view.showMatchPanel(show, state, secs)      
    }

    protected isAutoLeaveOnEnd(){
        return ModelData.instance.tableCommonData.autoLeaveWhenGameEnd
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let data = LoaclStorage.getJson('bipai_auto_leave_on_end')
        if(!data){
            return false
        }
        if(!data.roomId || data.roomId != roomInfo.roomId){
            return false
        }
        return true
    }

    protected setAutoLeaveOnEnd(autoLeave: boolean){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let key = ('bipai_auto_leave_on_end')
        let data: any = {}
        if(autoLeave){
            data.roomId = roomInfo.roomId
            
        }
        LoaclStorage.setJson(key, data)
    }

    protected cleanDesk(){
        let roomInfo = this.getRoomInfo() as BiPaiRoomInfo
        let mySeatInfo = roomInfo.mySeatInfo
        let seatInfoList = roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as BiPaiSeatInfo
            this.view.showSeatDispatchCards(seatInfo.localPos, false)
            this.view.showSeatHandCards(seatInfo.localPos, false)
            this.view.showSeatMingHandCardPoint(seatInfo.localPos, false, 0)
            this.view.showSeatMingHandCards(seatInfo.localPos, false)
            this.view.showSeatWatchTag(seatInfo.localPos, false)
            this.view.showSeatBankerTag(seatInfo.localPos, false)
            this.view.showSeatWinEffect(seatInfo.localPos, false)
            this.view.showSeatPiaoFen(seatInfo.localPos, false)      
            this.view.showSeatScore(seatInfo.localPos, false) 
            this.view.showWinCardPointAnim(seatInfo.localPos, false)   
            this.view.showMingWinAnim(seatInfo.localPos, false)
            this.view.showSanTiaoAnim(seatInfo.localPos, false)
            this.view.showShunZiAnim(seatInfo.localPos, false)
            this.view.showHuLuAnim(seatInfo.localPos, false)
            this.view.showTongHuaAnim(seatInfo.localPos, false)
            this.view.showSiTiaoAnim(seatInfo.localPos, false)     
            this.view.showZiMoWenZiAnim(seatInfo.localPos, false)     
            this.view.showFangPaoAnim(seatInfo.localPos, false)     
            this.view.showJiePaoWenZiAnim(seatInfo.localPos, false) 
            this.view.showTongHuaShunAnim(seatInfo.localPos, false) 
            this.view.showHuangJiaTongHuaShunAnim(seatInfo.localPos, false)  
            this.view.showSeatClock(seatInfo.localPos, false)
        }
        this.view.showFollowMultiple(false)
        this.view.showPokerHeap(false)        
        this.view.mySeatCards.showPokers(false)   
        this.view.mySeatCards.showResult(false)     
        this.view.showPokerRecorder(false, false, true)
        this.view.refreshOpenCardSuccessProgress(false)
    }
}

